module.exports = __webpack_public_path__ + "price-position-changed.svg?ba72c68197881510172b93110252f4f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price-position-changed.svg
// module id = 309
// module chunks = 2